<div class="translation-wrapper">
  <div class="selector-div-wrapper">
    <span>Activar</span>
    <div class="form-check form-switch">
      <input class="input-switch-sm form-check-input" type="checkbox" role="switch" id="translation-switch"
        [(ngModel)]="tool.enabled" [checked]="tool.enabled" />
    </div>
  </div>

  <div class="mb-3" *ngIf="tool.enabled">
    <!-- INT text -->
    <div class="selector-div-wrapper">
      <span class="text-note">S'eliminará (INT), (INT)R, (INT)E de los ID's</span>
      <!--       <div class="form-check form-switch">
        <input
          class="input-switch-sm form-check-input"
          type="checkbox"
          role="switch"
          id="translation-switch"
          [(ngModel)]="enableDefaultTranslation"
          [checked]="enableDefaultTranslation" />
      </div> -->
    </div>

    <!-- ADD FILE/TEXT -->
    <p class="title m-0">Añadir por:</p>
    <!-- Tabs -->
    <div class="tabs">
      <div class="tab">
        <button (click)="tabs.active = 'file'" [ngClass]="{ active: tabs.active === 'file' }">File</button>
      </div>
      <div class="tab">
        <button (click)="tabs.active = 'text'" [ngClass]="{ active: tabs.active === 'text' }">Text</button>
      </div>
    </div>
    <!-- Content -->
    <div class="tabs-content">
      <app-translation-file [hidden]="tabs.active !== 'file'" [tool]="tool"></app-translation-file>
      <app-translation-text [hidden]="tabs.active !== 'text'" [tool]="tool"></app-translation-text>
    </div>

    <!-- ADD FILE/TEXT -->
    <div class="d-flex align-items-center justify-content-between mb-3">
      <p class="title m-0">Traducciones (file + text):</p>
      <button *ngIf="tool.data !== null" role="button" class="btn-action-icon" (click)="downloadJson()">
        <i id="download"></i>
      </button>
    </div>
    <p class="text-note fst-italic">Las traducciones añadidas por texto tendrán prioridad.</p>

    <div class="translations-box jsonviewer-wrapper">
      <!-- <ngx-json-viewer [json]="tool.data" [expanded]="false"></ngx-json-viewer> -->
      <div *ngIf="tool.data !== null; else noData">
        <ngx-json-viewer [json]="tool.data" [expanded]="false"></ngx-json-viewer>
      </div>
      <ng-template #noData>
        <p class="text-note my-2 text-center">Aún no hay traducciones.</p>
      </ng-template>
    </div>
  </div>
</div>